import React from 'react';

import authService from '../services/auth.service';
import { toast } from 'react-toastify';

interface LogoutButtonProps {
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ className }) => {
  const handleLogout = async () => {
    try {
      await authService.logout();
      toast.success('Successfully logged out');
      // Force a page reload to update the authentication state
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to logout properly');
      // Still force a reload to the login page
      window.location.href = '/login';
    }
  };

  return (
    <button className={className} onClick={handleLogout}>
      <i className='ri-logout-box-line me-2'></i> Logout
    </button>
  );
};

export default LogoutButton;
